module.exports = __webpack_public_path__ + "static/img/shisan.8e059b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shisan.jpg
// module id = Sz0c
// module chunks = 1